export default __webpack_public_path__ + "static/imgOne-e11b20aef57f72f6b3c36d237a554f9b.jpg";